import type { DropdownOptionType } from "@booking/types";

export const TOP_COUNTRIES = [
  "England",
  "Wales",
  "Scotland",
  "Ireland",
  "Portugal",
  "Spain",
  "France",
  "Turkey",
];

export const ADDITIONAL_COUNTRIES = [
  "Antigua and Barbuda",
  "Argentina",
  "Australia",
  "Austria",
  "Bahamas",
  "Bahrain",
  "Barbados",
  "Bermuda",
  "Brazil",
  "Bulgaria",
  "Cambodia",
  "Canada",
  "China",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Dominican Republic",
  "Egypt",
  "Estonia",
  "Fiji",
  "Finland",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Isle of Man",
  "Italy",
  "Jamaica",
  "Japan",
  "Jersey",
  "Kenya",
  "Lithuania",
  "Malaysia",
  "Maldives",
  "Malta",
  "Mauritius",
  "Mexico",
  "Morocco",
  "Netherlands",
  "New Zealand",
  "Norway",
  "Oman",
  "Poland",
  "Puerto Rico",
  "Qatar",
  "Russian Federation",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Seychelles",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "South Africa",
  "Sri Lanka",
  "Sweden",
  "Switzerland",
  "Thailand",
  "Trinidad and Tobago",
  "Tunisia",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Zimbabwe",
];

export const SPECIAL_COUNTRIES: DropdownOptionType[] = [
  { value: "Taiwan, Province of China", text: "Taiwan" },
  { value: "Tanzania, United Republic of", text: "Tanzania" },
  { value: "Viet Nam", text: "Vietnam" },
];

export const AIRPORT_NAMES = [
  "London Heathrow",
  "London Gatwick",
  "Manchester",
  "London Stansted",
  "London Luton",
  "Edinburgh",
  "Birmingham",
  "Bristol",
  "Glasgow",
  "Belfast International",
  "Newcastle",
  "London City",
  "Liverpool",
  "East Midlands",
  "Leeds Bradford",
  "Aberdeen",
  "Belfast City",
  "London Southend",
  "Southampton",
  "Jersey",
  "Cardiff",
  "Doncaster Sheffield",
  "Exeter",
  "Glasgow Prestwick",
  "Other",
];

const createOption = (
  value: string,
  text?: string,
  disabled?: boolean,
): DropdownOptionType => ({
  value,
  text: text || value,
  ...(disabled ? { disabled } : {}),
});

export const DESTINATIONS: DropdownOptionType[] = [
  createOption("", "Any destination"),
  ...TOP_COUNTRIES.map((country) => createOption(country)),
  { value: "divider", text: "----------------------", disabled: true },
  ...ADDITIONAL_COUNTRIES.map((country) => createOption(country)),
  ...SPECIAL_COUNTRIES,
];

export const DEPARTURE_AIRPORTS: DropdownOptionType[] = [
  createOption("", "Select airport"),
  ...AIRPORT_NAMES.map((airport) => createOption(airport)),
];
